module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/electroguitar.png?a53002bf2fe679f5e2ad8060bd041002";